  query getReferralPlatforms(
    $clientId: ID
    $projectId: ID
    $productIds: [ID]
    $startDate: AWSDateTime
    $endDate: AWSDateTime
  ) {
    referralPlatforms: SalesAnalyticsGetReferralTotals(
      startDate: $startDate
      endDate: $endDate
      clientId: $clientId
      projectId: $projectId
      productIds: $productIds
      productView: BUNDLE
    ) {
      referralPlatform
      quantity
      sales
    }
  }